import React, { useContext } from 'react'
import { Routes, Route } from 'react-router-dom'

import UsersList from './Features/UsersList'

import NotFound from '../NotFound'

import { AbilityContext } from '../../components/Ability'


const UsersPage = () => {
  const ability = useContext(AbilityContext)

  return (
    <Routes>
      <Route
        path="/"
        element={
          ability.can('manage', 'User', 'userList') ? <UsersList /> : <NotFound />
        }
      />
    </Routes>
  )
}

export default UsersPage
